import { createReducer } from '@reduxjs/toolkit'

import { CreateReducer } from 'redux/utils'

import { changeSortModel } from './sorting.actions'

import type { SortingState } from '.'

export const sortDefaultState: SortingState = {
  sortModel: { field: '', ascending: true },
}

export const sortingReducer: CreateReducer<SortingState> = (sliceName, initialState) =>
  createReducer(
    {
      ...sortDefaultState,
      ...initialState,
    },
    builder => {
      builder.addCase(changeSortModel(sliceName), (state, { payload }) => {
        state.sortModel = payload
      })
    },
  )
